//服务器地址
export const SERVERURL = 'https://dt.gyycbj.com/api/'
//微信授权地址
export const WECHATAUTH = 'https://uc.gyycbj.com/api/wechat/oauth'
//微信授权回调地址 https://dt.gyycbj.com/jctx-web
export const WECHATREDITECT = 'https://dt.gyycbj.com/jctx-web'

